export const create = {
  form: {
    method: '洗剤プログラム情報',
    detergentUsed: '使用洗剤',
    no: '洗浄プログラムNo.',
    name: '洗浄プログラム名',
    customer: '会社名',
    volume: '洗浄量/%',
    cost: '洗浄費(1w)/円',
    time: '洗浄時間/分',
    washingTime: '洗浄時間',
    companyName: '会社名',
    detergentName: '洗剤名',
    waterName: '水量/l',
    quantity: '数量',
    unit: '単位',
    addNew: '新規追加',
    requireName: '洗浄プログラム名を入力してください',
    requireNo: '洗浄プログラムNo.を入力してください',
    requireVolume: '洗浄量/%を入力してください',
    requireCost: '洗浄費(1w)/円を入力してください',
    requireTime: '洗浄時間/分を入力してください',
    requireWashingTime: '洗浄プログラム名を入力してください',
    requireCompanyName: '会社名を入力してください',
    requireDetergentName: '洗剤名を入力してください',
    requireQuantity: '水量/lを入力してください',
    requireUnit: '単位を入力してください',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '洗浄プログラムリスト　新規追加画面',
    back: '戻る',
  },
}
